export const DESTINATION_TYPES = {
  HOTEL: 'hotel',
  REGION: 'region',
};

export const STATUSES = {
  OPEN: 'open',
  IN_WORK: 'in_work',
  WAIT_FOR_CLIENT: 'wait_for_client',
  WAIT_FOR_OPERATOR: 'wait_for_operator',
  WAIT_FOR_SERVICE: 'wait_for_service',
  CLOSED: 'closed',
  PLANNED: 'planned',
};

export const EXTRA_STATUSES = {
  CLOSED_BY_ORDER: 'closed_by_order',
  CLOSED_BY_REASON: 'closed_by_reason',
  CLOSE_ACTION: 'close_action',
};

// Пустой менеджер для селекторов по менеджерам в тикетах
export const EMPTY_MANAGER = {
  avatarUrl: null,
  email: '',
  id: 'none',
  name: 'Нет ответственного',
  phone: null,
  title: 'Нет ответственного',
  value: 'none',
};
